// assets
import { IconMap2 } from '@tabler/icons';

// constant
const icons = { IconMap2 };

const kioskSearch = {
  id: 'kiosk-search',
  title: 'Billboard Search',
  type: 'item',
  url: '/kiosk-search',
  icon: icons.IconMap2,
  breadcrumbs: false
};

export default kioskSearch;
